/**
 * The AI field (design.md B7). First names only, like the original. Jody
 * is the original's notorious car-stealer (Commodore Format, 1992).
 */
export interface DriverSpec {
  id: string;
  name: string;
  /** 3-letter tag shown on track and in the timing tower. */
  tag: string;
  /** The team this driver starts the season in. */
  teamId: string;
  /** 0.9 … 1.0: fraction of the field's base corner speed. */
  pace: number;
  /** 0 … 1: lap-to-lap variation (1 = metronome). */
  consistency: number;
  /** 0 … 1: how readily they try a pass and how close they follow. */
  aggression: number;
  /** 0 … 1: chance per lap of taking a known shortcut. */
  shortcut: number;
  /** Chance per corner of overcooking it. */
  mistakeRate: number;
  bio: string;
}

export const DRIVERS: readonly DriverSpec[] = [
  { id: 'tina', name: 'TINA', tag: 'TIN', teamId: 'marlin', pace: 1.0, consistency: 0.94, aggression: 0.55, shortcut: 0.25, mistakeRate: 0.006, bio: 'Reigning champion. Fast, precise, hard to rattle.' },
  { id: 'mick', name: 'MICK', tag: 'MCK', teamId: 'wolfe', pace: 0.99, consistency: 0.9, aggression: 0.65, shortcut: 0.5, mistakeRate: 0.01, bio: 'Holds the Desert City lap record. Loves a late lunge.' },
  { id: 'john', name: 'JOHN', tag: 'JHN', teamId: 'bramley', pace: 0.975, consistency: 0.86, aggression: 0.45, shortcut: 0.35, mistakeRate: 0.012, bio: 'Steady points-scorer. Rarely crashes, rarely wins.' },
  { id: 'josh', name: 'JOSH', tag: 'JSH', teamId: 'lotos', pace: 0.965, consistency: 0.8, aggression: 0.75, shortcut: 0.6, mistakeRate: 0.02, bio: 'Quick on his day. Knows every back alley.' },
  { id: 'jody', name: 'JODY', tag: 'JDY', teamId: 'ferro', pace: 0.95, consistency: 0.72, aggression: 0.95, shortcut: 0.85, mistakeRate: 0.03, bio: 'Slowest car, biggest grudge. Will challenge you for your seat.' },
];

export function driverById(id: string): DriverSpec | undefined {
  return DRIVERS.find((d) => d.id === id);
}
